import React, { Component } from 'react';
import { observer } from "mobx-react";
import StopListStore from 'Stores/StopList/stopListStore';
import Checkbox from "Components/Common/checkbox";
import AppStore from 'Stores/AppStore';
import { StopListItemDocumentDirection } from "Stores/models/Enums";
import Helper from 'Utils/Helper';

class StopListLine extends Component {
    render() {
        const { id, direction, regNum, regDate, userName, contactName, contactPost, isMain, errorDate, errorText } = this.props.record;

        let selected = StopListStore.selectedRecordsIds.some(it => it == id);
        let inProcess = StopListStore.processingRecordsIds.some(it => it == id);

        let isMeeting = AppStore.isMeeting;

        let clientAppTitle = isMeeting ? "ЭОС Совещания" : (AppStore.productModeSettings?.cbMode ? "МАРМ" : "EOSmobile");
        let directionText = '';
        switch (direction) {
            case StopListItemDocumentDirection.FromSmrToDmsis:
                directionText = 'Отправка из СМР в СЭД';
                break;
            case StopListItemDocumentDirection.FromSmrToClient:
                directionText = `Отправка из СМР в ${clientAppTitle}`;
                break;
            case StopListItemDocumentDirection.FromDmsisToSmr:
                directionText = 'Получение из СЭД в СМР';
                break;
        }

        return (
            <div className={"stop-list-line smr-table-line" + (selected ? ' selected' : '') + (inProcess ? ' disabled' : '')}>
                <div className="stop-list-line-content">
                    <div className="select-line-column">
                        <Checkbox checked={selected}
                            onChange={(state) => StopListStore.SelectItemInTable(id, state)} />
                    </div>
                    <div className="reg-num-column reg-num-column-width">
                        <div className="reg-num-column-reg-num">
                            {regNum}
                        </div>
                        <div className="stop-list-direction">
                            {directionText}
                        </div>
                    </div>
                    <div className="reg-date-column reg-date-column-width">
                        {regDate}
                    </div>
                    <div className="user-name-column user-name-column-width">
                        {userName ?? "Для всех"}
                    </div>
                    <div className="show-error-column show-error-column-width">
                        <button className="show-error-button"
                            onClick={_ => this.props.onShowErrorClicked({
                                id: id,
                                regNum: regNum,
                                userName: userName,
                                contactName: contactName,
                                contactPost: contactPost,
                                isMain: isMain,
                                errorText: errorText
                            })}>Посмотреть</button>
                    </div>
                    <div className="error-date-column error-date-column-width">
                        {errorDate}
                    </div>
                </div>
            </div>
        )
    }
}

export default observer(StopListLine);